import React from "react";

const PlanDetailRow = ({ label, value }) => (
  <div className="payment-plan-card__detail-row">
    <span className="payment-plan-card__detail-label">{label}</span>
    <span className="payment-plan-card__detail-value">{value}</span>
  </div>
);

const PlanDetails = ({ rows }) => (
  <div className="payment-plan-card__details">
    {rows.map((row) => (
      <PlanDetailRow key={row.label} label={row.label} value={row.value} />
    ))}
  </div>
);

export default PlanDetails;
